import Model from 'flarum/common/Model';
export default class TicketReply extends Model {
  message = Model.attribute('message');
  attachment = Model.attribute('attachment');
  isStaff = Model.attribute('isStaff');
  createdAt = Model.attribute('createdAt', Model.transformDate);
  user = Model.hasOne('user');
  ticket = Model.hasOne('ticket');
}
flarum.reg.add('cengizkemec-support-tickets', 'common/models/TicketReply', TicketReply);